const wowApp = require('angular').module('oly.common');

wowApp.factory('GuidFactory', [require('./guid-factory')]);



// WEBPACK FOOTER //
// ./src/olycommon/guid/index.js